import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { routes } from 'Constants/routes';
import * as Styled from '../../styles';
import { AccountDeleteProp } from './types';

const AccountDelete = ({ setScreen, setSubContent }: AccountDeleteProp): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const handleOnClick = (): void => {
    setScreen(2);
    history.replace(routes.ACCOUNT_DELETE_INFO);
    setSubContent(false);
  };
  return (
    <Styled.DeleteAccountButton type="button" onClick={handleOnClick}>
      {t('DeleteAccount.label')}
    </Styled.DeleteAccountButton>
  );
};

export default AccountDelete;
